import { createFileRoute } from '@tanstack/react-router';

import { CreativeEditorPage } from '../features/campaigns/creatives/components/CreativeEditor/CreativeEditorPage';
import { creativesRouteSearchSchema } from '../features/campaigns/creatives/creativesRouteSearch';
import { CreativeEditorMode, CreativeTab } from '../features/campaigns/creatives/model';

export const Route = createFileRoute('/campaigns/creatives_/video_/edit/$creativeId')({
  validateSearch: creativesRouteSearchSchema,
  component: VideoCreativeEditRoute,
});

function VideoCreativeEditRoute() {
  const { creativeId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <CreativeEditorPage
      tab={CreativeTab.Video}
      mode={CreativeEditorMode.Edit}
      brandId={search.brand ?? ''}
      creativeId={creativeId}
    />
  );
}
